import React from 'react';
import { handleADA } from '@dsg-tech/homefield-utils';
import { HomefieldIconPlArrowRight } from '@dsg-tech/homefield-react-icons';

type CustomNextArrowProps = {
  className: string;
  onClick: () => void;
};

const PLCarouselArrow = (props: CustomNextArrowProps) => {
  const { className, onClick } = props;
  return (
    <button
      type="button"
      className={className}
      onMouseDown={(e) => e.preventDefault()}
      onClick={onClick}
      onKeyDown={(e) => {
        handleADA(e, 'button', onClick);
      }}
      tabIndex={0}
      aria-label="PL arrow">
      <HomefieldIconPlArrowRight width="20px" height="20px" />
    </button>
  );
};

export default PLCarouselArrow;
